import React, { useState } from 'react';
import PageCommunitySelectWrapper from '../../components/common/page_community_select_wrapper';
import { useCommunitySelectHistory } from '../../hooks/use_community_select_history';
import ReviewSnippetsPicker from './review_snippets_picker';
import ReviewSnippetsMultiFacilityTable from './review_snippets_multi_facility_table';
import { getSingleProperty } from '../../utils/common';
import { RootState } from '../../store/reducers';
import { useSelector } from 'react-redux';

const ReviewShowcase = () => {
    const { Properties, Session, Org } = useSelector(
        ({ SessionState }: RootState) => SessionState
    );
    
    const { SessionType } = Session;
    const singleProperty = getSingleProperty(SessionType, 0, Properties);

    const initialNHID = singleProperty ? singleProperty.NHID : null;
    const [ selNHID, setSelNHID ] = useState<number | null>(initialNHID);

    const handleSelect = useCommunitySelectHistory((selNHID: number) => {
        if (!singleProperty) {
            setSelNHID(selNHID);
        }
    });

    return (
        <>
            <PageCommunitySelectWrapper
                handleSelect={handleSelect}
                selNHID={selNHID}
            />
            <section>
                <div className="container max-w-none 2xl:container mt-4 sm:mt-6 md:mt-8 2xl:mt-10">
                    {selNHID && <ReviewSnippetsPicker selNHID={selNHID} />}
                    {!selNHID && <ReviewSnippetsMultiFacilityTable handleSelect={handleSelect} />}
                </div>
            </section>
        </>
    );

};

export default ReviewShowcase;
